import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "rundeck-version-name",
  style: {"margin-left":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "rundeck-version-icon",
    style: _normalizeStyle({ color: _ctx.color })
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["glyphicon", ['glyphicon-' + _ctx.icon]])
    }, null, 2),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.text), 1)
  ], 4))
}